import Vue from 'vue'

export const loadData = ({commit}) => {
    Vue.http.get('data.json')
    .then(response => response.json() )
    .then(data => {
        if(data) {
            const stocks = data.stocks
            const funds = data.fundsconst 
            const stockPortfolio = data.stockPortfolio

            const portfolio = {
                stockPortfolio,
                funds
            }

            commit('SET_STOCKS', stocks)
            commit('SET_PORTFOLIO', portfolio)
        }
    })
}


// WEBPACK FOOTER //
// ./src/store/actions.js